import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "@/assets/logo-white.png";

const MarketingHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  // Scroll to section after navigation from other pages
  useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      const sectionId = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);

  const handleScrollLink = (e: React.MouseEvent, sectionId: string) => {
    e.preventDefault();
    if (isHomePage) {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  const handleHomeClick = (e: React.MouseEvent) => {
    if (isHomePage) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-card/50 backdrop-blur-xl">
      <div className="container mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-3">
          <img src={logo} alt="PROduce Logo" className="h-10" />
        </Link>
        <nav className="hidden items-center gap-6 md:flex">
          <Link
            to="/"
            onClick={handleHomeClick}
            className={`text-sm transition-colors ${
              isActive("/")
                ? "font-medium text-primary"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            Home
          </Link>
          <Link
            to="/user-cases"
            className={`text-sm transition-colors ${
              isActive("/user-cases")
                ? "font-medium text-primary"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            Use cases
          </Link>
          <Link
            to="/field-guide"
            className={`text-sm transition-colors ${
              isActive("/field-guide") || location.pathname.startsWith("/field-guide/")
                ? "font-medium text-primary"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            Field guide
          </Link>
          <a
            href="#features"
            onClick={(e) => handleScrollLink(e, "features")}
            className="cursor-pointer text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            Features
          </a>
          <a
            href="#pricing"
            onClick={(e) => handleScrollLink(e, "pricing")}
            className="cursor-pointer text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            Pricing
          </a>
          <a
            href="#faq"
            onClick={(e) => handleScrollLink(e, "faq")}
            className="cursor-pointer text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            FAQ
          </a>
          <Link
            to="/contact"
            className={`text-sm transition-colors ${
              isActive("/contact")
                ? "font-medium text-primary"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            Contact
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default MarketingHeader;
